import { useEffect, useState } from "react";
import Headshot from "../../images/headshot.jpeg";
import "../../styles/Navigation.css";

const Navigation = () => {
  const [section, setSection] = useState("home");

  const changeNav = (entries) => {
    const [entry] = entries;
    setSection(entry.target.id);
  };

  useEffect(() => {
    const options = {
      threshold: 0.55,
    };

    const observer = new IntersectionObserver(changeNav, options);

    const sections = document.querySelectorAll("section");
    sections.forEach((section) => {
      observer.observe(section);
    });
  }, []);

  return (
    <nav className="nav">
      <div className="nav__logo">
        <p>Jarrod</p>
      </div>
      <div className="nav__image">
        <div className="nav__image-container">
          <img
            src={Headshot}
            alt="me"
            className="nav__image-container--image"
          />
        </div>
      </div>
      <ul className="nav__links">
        <a
          href="#home"
          style={{ color: `${section === "home" ? "#1a9a92" : ""}` }}
        >
          <li>
            <span>
              <i className="fa-solid fa-house"></i>
            </span>
            Home
          </li>
        </a>
        <a
          href="#about"
          style={{ color: `${section === "about" ? "#1a9a92" : ""}` }}
        >
          <li>
            <span>
              <i className="fa-regular fa-address-card"></i>
            </span>
            About Me
          </li>
        </a>
        <a
          href="#technologies"
          style={{ color: `${section === "technologies" ? "#1a9a92" : ""}` }}
        >
          <li>
            <span>
              <i className="fa-solid fa-sliders"></i>
            </span>
            Skills
          </li>
        </a>
        <a
          href="#projects"
          style={{ color: `${section === "projects" ? "#1a9a92" : ""}` }}
        >
          <li>
            <span>
              <i className="fa-solid fa-briefcase"></i>
            </span>
            Projects
          </li>
        </a>
        <a
          href="#contact"
          style={{ color: `${section === "contact" ? "#1a9a92" : ""}` }}
        >
          <li>
            <span>
              <i className="fa-regular fa-map"></i>
            </span>
            Contact
          </li>
        </a>
      </ul>
      <div className="nav__socials">
        <a href="https://github.com/gillijar" target="_blank" rel="noreferrer">
          <i className="fa-brands fa-github"></i>
        </a>
        <a
          href="https://www.linkedin.com/in/jarrod-gilliland/"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fa-brands fa-linkedin"></i>
        </a>
      </div>
    </nav>
  );
};

export default Navigation;
